module.exports = __webpack_public_path__ + "static/media/canadian-owned-dt-en.2c83e607.jpg";